export default __webpack_public_path__ + "static/media/orange.2f9eed99.png";